
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { UserOrganization } from '../types/organization.types';

interface UserOrganizationsListProps {
  userOrganizations: UserOrganization[];
}

const UserOrganizationsList: React.FC<UserOrganizationsListProps> = ({ userOrganizations }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {userOrganizations.map((userOrg) => (
        <Card key={userOrg.id}>
          <CardHeader>
            <CardTitle>{userOrg.organizations.name}</CardTitle>
            <CardDescription>{userOrg.organizations.description || 'No description'}</CardDescription>
          </CardHeader>
          <CardFooter>
            <Badge variant="outline">{userOrg.role}</Badge>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};

export default UserOrganizationsList;
